export default "__VITE_ASSET__BZNDba$B__"